export const SDK_VERSION = '1.9.6';
